import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";

// The page frame inside the shell: a header (PageHeader), then the body with
// the page's own sections. Nothing here draws a box; space separates.

const styles = {
  page: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    k7Eaqz: "xeuugli",
    kAzted: "x1us19tq",
    $$css: true
  },
  body: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1dfszw7",
    k7Eaqz: "xeuugli",
    kg3NbH: "x13q3zuf",
    kLKAdn: "xh0uz7e",
    kGO01o: "xk257kh",
    $$css: true
  },
  narrow: {
    ks0D6T: "x1uedy8c",
    $$css: true
  },
  flush: {
    kg3NbH: "xnjsko4",
    kLKAdn: "xexx8yu",
    kGO01o: "x18d9i69",
    kOIVth: "xxhr3t",
    kUk6DE: "x98rzlu",
    kAzted: "x2lwn1j",
    $$css: true
  },
  section: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x5vihii",
    k7Eaqz: "xeuugli",
    $$css: true
  }
};
export function Page({
  children,
  xstyle
}: {
  children: ReactNode;
  xstyle?: stylex.StyleXStyles;
}) {
  return <div {...stylex.props(styles.page, xstyle)}>{children}</div>;
}
export function PageBody({
  children,
  narrow = false,
  flush = false,
  xstyle
}: {
  children: ReactNode;
  /** Forms and settings read best in a narrower column. */
  narrow?: boolean;
  /** A full-bleed workspace (a canvas, a sheet) owns its own padding. */
  flush?: boolean;
  xstyle?: stylex.StyleXStyles;
}) {
  return <div {...stylex.props(styles.body, narrow && styles.narrow, flush && styles.flush, xstyle)}>
      {children}
    </div>;
}
export function Section({
  title,
  actions,
  children,
  "aria-label": ariaLabel,
  xstyle
}: {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  "aria-label"?: string;
  xstyle?: stylex.StyleXStyles;
}) {
  return <section aria-label={ariaLabel} {...stylex.props(styles.section, xstyle)}>
      {(title || actions) && <div className="x78zum5 x6s0dn4 x166cprz x21xpn4">
          {title && <h2 className="x98rzlu xeuugli x1ghz6dp xdj3nnt xk50ysn xgwkh9f">{title}</h2>}
          {actions && <div className="x78zum5 x6s0dn4 xsuxsxl">{actions}</div>}
        </div>}
      {children}
    </section>;
}